import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useCreatePinCodeMutation } from "@/services/api/entities/pinCode";
import { selectAuthStatus, useAuth } from "@/services/auth";
import { useAppSelector } from "@/services/store";
import { appRouterPaths } from "@/services/navigation";

export const useCheckStatus = () => {
  const navigate = useNavigate();
  const authStatus = useAppSelector(selectAuthStatus);

  const { accessPinHandler } = useAuth();

  const [createPinCode, { isLoading: pinFetching }] = useCreatePinCodeMutation();

  const handleCreatePin = useCallback(
    (pin: string) => {
      createPinCode({ pin })
        .unwrap()
        .then(() => {
          accessPinHandler(pin);
        })
        .catch(() => {
          navigate(appRouterPaths.logIn);
        });
    },
    [createPinCode, navigate],
  );

  return {
    state: {
      authStatus,
      pinFetching,
    },
    methods: {
      handleCreatePin,
    },
  };
};
